import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useDispatch} from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import {faBars} from '@fortawesome/pro-regular-svg-icons';

import MenuDrawer from './MenuDrawer';
import Stepper from './Stepper';
import {completeExercise} from '../redux/slices/lesson';

import baseStyles from '../css/Base.module.css';

export default function PrimaryAppBar({showDoneButton = true}) {
  const [isMenuOpen, toggleMenu] = useState(false);
  const dispatch = useDispatch();

  function handleCompleteExercise() {
    dispatch(completeExercise());
  }

  return <>
    <MenuDrawer isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />

    <div className={baseStyles['f-g-1']}>
      <AppBar position="sticky" className="bg-brandorange">
        <Toolbar variant="dense">
          <IconButton
            edge="start"
            className={baseStyles['m-r-15']}
            color="inherit"
            onClick={() => toggleMenu(!isMenuOpen)}
            size="large">
            <FontAwesomeIcon icon={faBars} size="xs" />
          </IconButton>
          <Stepper />
          <Typography variant="h6" className={baseStyles['f-g-1']}></Typography>
          {showDoneButton && (
            <Button color="inherit" onClick={handleCompleteExercise} className={baseStyles['btn-pill']}>
              I&apos;M READY TO MOVE ON
            </Button>
          )}
        </Toolbar>
      </AppBar>
    </div>
  </>;
}
